import { evaluation360 } from '../../i18n/translatedMessages'
import { HiCheckCircle } from 'react-icons/hi2'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

export function ModalConfirmation({ show, setShow }) {
	return (
		<>
			{show && (
				<div className='tw-w-screen tw-h-screen tw-absolute tw-top-0 tw-left-0 tw-bg-black/50 tw-backdrop-blur-sm tw-flex tw-items-center tw-justify-center'>
					<div className='tw-w-[546px] tw-bg-white tw-rounded-md tw-p-6'>
						<h1 className='tw-text-purple tw-text-center'>
							<HiCheckCircle size={58} />
						</h1>
						<h3 className='tw-text-center tw-mb-8 tw-mt-4'>{evaluation360.modal360ConfirmationTitle}</h3>
						<button
							className='tw-my-2 tw-w-full tw-rounded-full tw-py-2 tw-bg-purple tw-text-white hover:tw-bg-purple-700 active:tw-bg-purple-700'
							style={{ border: '1px solid rgb(122, 107, 232)' }}
							onClick={() => setShow(false)}
						>
							{evaluation360.btnAddEvaluation}
						</button>
						<Link to='/employee/evaluation/historical' className='tw-w-full'>
							<button
								onClick={() => setShow(false)}
								className='tw-w-full tw-rounded-full tw-py-2 tw-bg-white tw-text-gray-700 hover:tw-bg-gray-200 active:tw-bg-gray-300 border'
							>
								{evaluation360.btnHistoricEvaluation}
							</button>
						</Link>
					</div>
				</div>
			)}
		</>
	)
}
